export default __webpack_public_path__ + "static/media/ref2.01b1d1ea.mp3";